/* ==========================================================================
   Testimonials Carousel Component ("What Security Leaders Say About SED")
   Movable, smooth sliding carousel with navigation controls & verified media links.
   100% Multi-Language i18n
   ========================================================================== */

import { t, getLocale } from '../locales/i18n.js';

const testimonialsData = {
  en: [
    {
      name: 'Roman Zarzycký',
      role: 'Mayor of the City of Pilsen',
      quote: 'We have already tested the sensors on Americká Street and in real operation we have been convinced that they really work. Currently, they detect gunshots, panic screams and glass breakage with a very high level of reliability.',
      img: '/images/Untitled-design-2024-02-10T232240.825-1.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/plzen-rozsirila-svuj-mestsky-kamerovy-system/',
      sourceLabel: 'City Press Report (Plzeň.eu) ↗'
    },
    {
      name: 'Zdeněk Procházka',
      role: 'Head of Security, University Hospital',
      quote: 'JALUD Embedded’s Sound Event Detectors proved themselves in testing with their unusual accuracy and ability to detect non-standard sounds, simplicity of installation and links to established integrated security systems.',
      img: '/images/Untitled-design-2024-02-10T232255.979-1.png',
      sourceUrl: 'https://ct24.ceskatelevize.cz/domaci/3511096-riziko-utoku-na-kritickou-infrastrukturu-roste-nejhure-jsou-zabezpeceny-nemocnice',
      sourceLabel: 'Hospital Security Report (ČT24) ↗'
    },
    {
      name: 'Doug Sear',
      role: 'Global Security Technology Expert',
      quote: "In my opinion the Sound Event Detector will save lives. We've now gained another one of the critical senses (Hearing) to compliment CCTV (Eyes) and respond to dangerous events much more quickly.",
      img: '/images/Untitled-design-2024-02-10T232315.843-1.png',
      sourceUrl: 'https://www.youtube.com/watch?v=GTbZe57l75Q',
      sourceLabel: 'Watch Official Video ↗'
    },
    {
      name: 'Ing. Luděk Šantora',
      role: 'Director of SITMP (Information Tech Pilsen)',
      quote: 'The undisputed advantage of this solution is the ability to identify and locate the incident site on map layers in real time and dispatch the nearest emergency response unit to the scene.',
      img: '/images/logo-sitmp.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/oceneni-v-soutezi-vizionari-2023-putuji-do-plzne-pro-jalud-embedded-a-ludka-santoru/',
      sourceLabel: 'Visionaries 2023 Award Press ↗'
    },
    {
      name: 'Fabio Faria',
      role: 'Security VMS Product Manager',
      quote: 'Native VMS integration allows security operators to receive real-time audio snippet alerts and 360° PTZ camera auto-slew vectors instantly.',
      img: '/images/Untitled-design-2024-02-10T232332.102-1.png',
      sourceUrl: 'https://securityguide.cz/v-plzni-se-uskutecnil-ostry-test-zabezpeceni-kriticke-infrastruktury-v-ceske-republice-jak-dobre-je-chranena/',
      sourceLabel: 'VMS Field Test Review ↗'
    },
    {
      name: 'Joost van der Velden',
      role: 'European Security Solutions Director',
      quote: 'We have been working with JALUD since November 2021. Communication is smooth and they have always helped us with any inquiry. We are very pleased to be their Dutch partner.',
      img: '/images/logo-remoticom.png',
      sourceUrl: null,
      sourceLabel: null
    }
  ],
  cs: [
    {
      name: 'Roman Zarzycký',
      role: 'Primátor města Plzně',
      quote: 'Senzory jsme otestovali v ostrém provozu na Americké třídě a přesvědčili jsme se, že spolehlivě fungují. V současnosti s vysokou přesností a spolehlivostí detekují střelbu, panický křik i tříštění skla.',
      img: '/images/Untitled-design-2024-02-10T232240.825-1.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/plzen-rozsirila-svuj-mestsky-kamerovy-system/',
      sourceLabel: 'Tisková zpráva města (Plzeň.eu) ↗'
    },
    {
      name: 'Zdeněk Procházka',
      role: 'Bezpečnostní ředitel, Fakultní nemocnice',
      quote: 'Detektory Sound Event Detector společnosti JALUD Embedded se v testování osvědčily mimořádnou přesností, schopností rozpoznat nestandardní zvuky, jednoduchou instalací a provázáním se zavedenými bezpečnostními systémy.',
      img: '/images/Untitled-design-2024-02-10T232255.979-1.png',
      sourceUrl: 'https://ct24.ceskatelevize.cz/domaci/3511096-riziko-utoku-na-kritickou-infrastrukturu-roste-nejhure-jsou-zabezpeceny-nemocnice',
      sourceLabel: 'Zpráva ČT24 o bezpečnosti nemocnic ↗'
    },
    {
      name: 'Doug Sear',
      role: 'Mezinárodní bezpečnostní expert',
      quote: 'Podle mého názoru Sound Event Detector zachraňuje lidské životy. Získali jsme další z kritických smyslů (sluch), který doplňuje kamerové systémy (zrak), a umožňuje reagovat na nebezpečné události nesrovnatelně rychleji.',
      img: '/images/Untitled-design-2024-02-10T232315.843-1.png',
      sourceUrl: 'https://www.youtube.com/watch?v=GTbZe57l75Q',
      sourceLabel: 'Přehrát oficiální video ↗'
    },
    {
      name: 'Ing. Luděk Šantora',
      role: 'Ředitel SITMP (Správa informačních technologií města Plzně)',
      quote: 'Nespornou výhodou tohoto řešení je schopnost v reálném čase identifikovat a v mapových podkladech lokalizovat místo incidentu a vyslat na místo události nejbližší zásahovou jednotku.',
      img: '/images/logo-sitmp.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/oceneni-v-soutezi-vizionari-2023-putuji-do-plzne-pro-jalud-embedded-a-ludka-santoru/',
      sourceLabel: 'Tisková zpráva Vizionáři 2023 ↗'
    },
    {
      name: 'Fabio Faria',
      role: 'Produktový manažer pro bezpečnostní VMS platformy',
      quote: 'Nativní integrace s VMS systémy umožňuje operátorům přijímat okamžitá poplachová hlášení s audio výstřižky a automaticky navádět PTZ kamery do 360° úhlu.',
      img: '/images/Untitled-design-2024-02-10T232332.102-1.png',
      sourceUrl: 'https://securityguide.cz/v-plzni-se-uskutecnil-ostry-test-zabezpeceni-kriticke-infrastruktury-v-ceske-republice-jak-dobre-je-chranena/',
      sourceLabel: 'Recenze zátěžového testu VMS ↗'
    },
    {
      name: 'Joost van der Velden',
      role: 'Ředitel pro evropská bezpečnostní řešení',
      quote: 'Se společností JALUD spolupracujeme od listopadu 2021. Komunikace je plynulá a vždy nám pomohli s jakýmkoliv dotazem. Jsme velmi rádi, že jsme jejich nizozemským partnerem.',
      img: '/images/logo-remoticom.png',
      sourceUrl: null,
      sourceLabel: null
    }
  ],
  de: [
    {
      name: 'Roman Zarzycký',
      role: 'Oberbürgermeister der Stadt Pilsen',
      quote: 'Wir haben die Sensoren im Realbetrieb getestet und festgestellt, dass sie absolut zuverlässig funktionieren. Sie erkennen Schüsse, Panikschreie und Glasbruch mit höchster Genauigkeit.',
      img: '/images/Untitled-design-2024-02-10T232240.825-1.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/plzen-rozsirila-svuj-mestsky-kamerovy-system/',
      sourceLabel: 'Stadtbericht (Plzeň.eu) ↗'
    },
    {
      name: 'Zdeněk Procházka',
      role: 'Sicherheitschef, Universitätsklinikum',
      quote: 'Die Sound Event Detectors von JALUD Embedded überzeugen durch ihre außergewöhnliche Präzision, die Erkennung atypischer Geräusche und die einfache Integration in bestehende Sicherheitssysteme.',
      img: '/images/Untitled-design-2024-02-10T232255.979-1.png',
      sourceUrl: 'https://ct24.ceskatelevize.cz/domaci/3511096-riziko-utoku-na-kritickou-infrastrukturu-roste-nejhure-jsou-zabezpeceny-nemocnice',
      sourceLabel: 'Krankenhaus-Sicherheitsbericht (ČT24) ↗'
    },
    {
      name: 'Doug Sear',
      role: 'Globaler Sicherheitstechnologie-Experte',
      quote: 'Meiner Ansicht nach rettet der Sound Event Detector Leben. Wir haben das Gehör als entscheidenden Sinn gewonnen, um Kamerasysteme zu ergänzen und Notfallreaktionen zu beschleunigen.',
      img: '/images/Untitled-design-2024-02-10T232315.843-1.png',
      sourceUrl: 'https://www.youtube.com/watch?v=GTbZe57l75Q',
      sourceLabel: 'Offizielles Video ansehen ↗'
    },
    {
      name: 'Ing. Luděk Šantora',
      role: 'Direktor SITMP (Informationstechnologie Pilsen)',
      quote: 'Der unbestreitbare Vorteil dieser Lösung ist die Fähigkeit, den Vorfallsort in Echtzeit auf Karten zu identifizieren, zu lokalisieren und die nächstgelegene Einsatzkraft direkt zum Ort des Geschehens zu entsenden.',
      img: '/images/logo-sitmp.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/oceneni-v-soutezi-vizionari-2023-putuji-do-plzne-pro-jalud-embedded-a-ludka-santoru/',
      sourceLabel: 'Visionäre 2023 Auszeichnung ↗'
    },
    {
      name: 'Fabio Faria',
      role: 'Produktmanager für Sicherheits-VMS-Plattformen',
      quote: 'Die native VMS-Integration ermöglicht es Sicherheitskräften, Alarmmeldungen mit Audioausschnitten in Echtzeit zu erhalten und PTZ-Kameras sofort auszurichten.',
      img: '/images/Untitled-design-2024-02-10T232332.102-1.png',
      sourceUrl: 'https://securityguide.cz/v-plzni-se-uskutecnil-ostry-test-zabezpeceni-kriticke-infrastruktury-v-ceske-republice-jak-dobre-je-chranena/',
      sourceLabel: 'VMS Feldtestbericht ↗'
    },
    {
      name: 'Joost van der Velden',
      role: 'Direktor für europäische Sicherheitslösungen',
      quote: 'Wir arbeiten seit November 2021 mit JALUD zusammen. Die Kommunikation ist reibungslos und sie haben uns bei jeder Anfrage stets geholfen. Wir freuen uns sehr, ihr niederländischer Partner zu sein.',
      img: '/images/logo-remoticom.png',
      sourceUrl: null,
      sourceLabel: null
    }
  ],
  es: [
    {
      name: 'Roman Zarzycký',
      role: 'Alcalde de la ciudad de Pilsen',
      quote: 'Hemos probado los sensores en situaciones reales y comprobado que funcionan con gran eficacia. Actualmente detectan disparos, gritos de pánico y rotura de cristales con máxima fiabilidad.',
      img: '/images/Untitled-design-2024-02-10T232240.825-1.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/plzen-rozsirila-svuj-mestsky-kamerovy-system/',
      sourceLabel: 'Informe municipal (Plzeň.eu) ↗'
    },
    {
      name: 'Zdeněk Procházka',
      role: 'Director de Seguridad, Hospital Universitario',
      quote: 'Los detectores Sound Event Detector de JALUD Embedded demostraron una precisión extraordinaria en las pruebas, detectando sonidos anómalos y facilitando la integración con los sistemas existentes.',
      img: '/images/Untitled-design-2024-02-10T232255.979-1.png',
      sourceUrl: 'https://ct24.ceskatelevize.cz/domaci/3511096-riziko-utoku-na-kritickou-infrastrukturu-roste-nejhure-jsou-zabezpeceny-nemocnice',
      sourceLabel: 'Informe de seguridad hospitalaria (ČT24) ↗'
    },
    {
      name: 'Doug Sear',
      role: 'Experto internacional en tecnologías de seguridad',
      quote: 'En mi opinión, Sound Event Detector salvará vidas. Ahora disponemos del oído como sentido crítico para complementar a las cámaras y responder mucho más rápido.',
      img: '/images/Untitled-design-2024-02-10T232315.843-1.png',
      sourceUrl: 'https://www.youtube.com/watch?v=GTbZe57l75Q',
      sourceLabel: 'Ver vídeo oficial ↗'
    },
    {
      name: 'Ing. Luděk Šantora',
      role: 'Director de SITMP (Tecnología de la Información Pilsen)',
      quote: 'La ventaja indiscutible de esta solución es la capacidad de identificar y localizar el lugar del incidente en capas de mapas en tiempo real y enviar la unidad de intervención más cercana al lugar.',
      img: '/images/logo-sitmp.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/oceneni-v-soutezi-vizionari-2023-putuji-do-plzne-pro-jalud-embedded-a-ludka-santoru/',
      sourceLabel: 'Premio Visionarios 2023 ↗'
    },
    {
      name: 'Fabio Faria',
      role: 'Gestor de producto VMS de seguridad',
      quote: 'La integración nativa con VMS permite a los operadores recibir alertas instantáneas con clips de audio y redirigir cámaras PTZ en 360° de forma automática.',
      img: '/images/Untitled-design-2024-02-10T232332.102-1.png',
      sourceUrl: 'https://securityguide.cz/v-plzni-se-uskutecnil-ostry-test-zabezpeceni-kriticke-infrastruktury-v-ceske-republice-jak-dobre-je-chranena/',
      sourceLabel: 'Informe de pruebas de campo VMS ↗'
    },
    {
      name: 'Joost van der Velden',
      role: 'Director de Soluciones de Seguridad Europea',
      quote: 'Colaboramos con JALUD desde noviembre de 2021. La comunicación es fluida y siempre nos han ayudado con cualquier consulta. Estamos muy satisfechos de ser su socio en los Países Bajos.',
      img: '/images/logo-remoticom.png',
      sourceUrl: null,
      sourceLabel: null
    }
  ],
  pt: [
    {
      name: 'Roman Zarzycký',
      role: 'Prefeito da Cidade de Pilsen',
      quote: 'Testamos os sensores em operação real e comprovamos que eles realmente funcionam com alta confiabilidade na detecção de disparos, gritos de pânico e quebra de vidros.',
      img: '/images/Untitled-design-2024-02-10T232240.825-1.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/plzen-rozsirila-svuj-mestsky-kamerovy-system/',
      sourceLabel: 'Relatório Municipal (Plzeň.eu) ↗'
    },
    {
      name: 'Zdeněk Procházka',
      role: 'Diretor de Segurança, Hospital Universitário',
      quote: 'Os detectores Sound Event Detector da JALUD Embedded provaram sua precisão incomum, facilidade de instalação e integração perfeita com sistemas existentes.',
      img: '/images/Untitled-design-2024-02-10T232255.979-1.png',
      sourceUrl: 'https://ct24.ceskatelevize.cz/domaci/3511096-riziko-utoku-na-kritickou-infrastrukturu-roste-nejhure-jsou-zabezpeceny-nemocnice',
      sourceLabel: 'Relatório Hospitalar (ČT24) ↗'
    },
    {
      name: 'Doug Sear',
      role: 'Especialista Global em Tecnologia de Segurança',
      quote: 'Em minha opinião, o Sound Event Detector salva vidas. Ganhamos a audição como sentido crítico para complementar as câmeras e responder muito mais rápido.',
      img: '/images/Untitled-design-2024-02-10T232315.843-1.png',
      sourceUrl: 'https://www.youtube.com/watch?v=GTbZe57l75Q',
      sourceLabel: 'Assistir Vídeo Oficial ↗'
    },
    {
      name: 'Ing. Luděk Šantora',
      role: 'Diretor da SITMP (Tecnologia da Informação Pilsen)',
      quote: 'A vantagem indiscutível desta solução é a capacidade de identificar e localizar o local do incidente em mapas em tempo real e enviar a unidade de resposta mais próxima ao local.',
      img: '/images/logo-sitmp.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/oceneni-v-soutezi-vizionari-2023-putuji-do-plzne-pro-jalud-embedded-a-ludka-santoru/',
      sourceLabel: 'Prêmio Visionários 2023 ↗'
    },
    {
      name: 'Fabio Faria',
      role: 'Gerente de Produtos VMS de Segurança',
      quote: 'A integração nativa com VMS permite aos operadores receber alertas instantâneos com amostras de áudio e direcionar câmeras PTZ automaticamente.',
      img: '/images/Untitled-design-2024-02-10T232332.102-1.png',
      sourceUrl: 'https://securityguide.cz/v-plzni-se-uskutecnil-ostry-test-zabezpeceni-kriticke-infrastruktury-v-ceske-republice-jak-dobre-je-chranena/',
      sourceLabel: 'Avaliação de Teste VMS ↗'
    },
    {
      name: 'Joost van der Velden',
      role: 'Diretor de Soluções Europeias de Segurança',
      quote: 'Trabalhamos com a JALUD desde novembro de 2021. A comunicação é fluida e eles sempre nos ajudaram com qualquer dúvida. Estamos muito satisfeitos em ser seu parceiro holandês.',
      img: '/images/logo-remoticom.png',
      sourceUrl: null,
      sourceLabel: null
    }
  ],
  ar: [
    {
      name: 'Roman Zarzycký',
      role: 'عمدة مدينة بلزن',
      quote: 'لقد اختبرنا أجهزة الاستشعار في بيئة التشغيل الفعلية وتأكدنا من فعاليتها العالية في كشف إطلاق النار وصراخ الهلع وكسر الزجاج بأقصى درجات الموثوقية.',
      img: '/images/Untitled-design-2024-02-10T232240.825-1.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/plzen-rozsirila-svuj-mestsky-kamerovy-system/',
      sourceLabel: 'تقرير البلدية (Plzeň.eu) ↗'
    },
    {
      name: 'Zdeněk Procházka',
      role: 'مدير الأمن، المستشفى الجامعي',
      quote: 'أثبتت كواشف SED من شركة JALUD دقة غير عادية في التعرف على الأصوات الشاذة وسهولة التركيب والربط مع أنظمة الأمان المتكاملة.',
      img: '/images/Untitled-design-2024-02-10T232255.979-1.png',
      sourceUrl: 'https://ct24.ceskatelevize.cz/domaci/3511096-riziko-utoku-na-kritickou-infrastrukturu-roste-nejhure-jsou-zabezpeceny-nemocnice',
      sourceLabel: 'تقرير أمن المستشفيات (ČT24) ↗'
    },
    {
      name: 'Doug Sear',
      role: 'خبير دولي في تقنيات الأمن',
      quote: 'في رأيي كاشف الأصوات SED ينقذ الأرواح. لقد اكتسبنا حاسة السمع لتكملة كاميرات المراقبة والاستجابة للتهديدات بسرعة فائقة.',
      img: '/images/Untitled-design-2024-02-10T232315.843-1.png',
      sourceUrl: 'https://www.youtube.com/watch?v=GTbZe57l75Q',
      sourceLabel: 'شاهد الفيديو الرسمي ↗'
    },
    {
      name: 'Ing. Luděk Šantora',
      role: 'مدير SITMP (إدارة تكنولوجيا المعلومات ببلزن)',
      quote: 'الميزة التي لا جدال فيها لهذا الحل هي القدرة على التعرف على موقع الحادث وتحديده على خرائط الموقع في الوقت الفعلي وإرسال أقرب وحدة تدخل فوري إلى مكان الحدث.',
      img: '/images/logo-sitmp.png',
      sourceUrl: 'https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/oceneni-v-soutezi-vizionari-2023-putuji-do-plzne-pro-jalud-embedded-a-ludka-santoru/',
      sourceLabel: 'جائزة الابتكار 2023 ↗'
    },
    {
      name: 'Fabio Faria',
      role: 'مدير منتجات VMS الأمنية',
      quote: 'يتيح التكامل المباشر مع منصات VMS للمشغلين تلقي تنبيهات مقاطع الصوت الفورية والتوجيه التلقائي لكاميرات PTZ بدقة 360 درجة.',
      img: '/images/Untitled-design-2024-02-10T232332.102-1.png',
      sourceUrl: 'https://securityguide.cz/v-plzni-se-uskutecnil-ostry-test-zabezpeceni-kriticke-infrastruktury-v-ceske-republice-jak-dobre-je-chranena/',
      sourceLabel: 'تقرير اختبارات VMS ↗'
    },
    {
      name: 'Joost van der Velden',
      role: 'مدير الحلول الأمنية الأوروبية',
      quote: 'نحن نتعاون مع شركة JALUD منذ نوفمبر 2021. التواصل سلس للغاية وقد ساعدونا دائماً في أي استفسار. نحن سعداء جداً بكوننا شريكهم في هولندا.',
      img: '/images/logo-remoticom.png',
      sourceUrl: null,
      sourceLabel: null
    }
  ]
};

export function renderTestimonialsCarousel() {
  const section = document.createElement('section');
  section.className = 'sed-section-alt sed-testimonials-section';
  section.style.backgroundColor = 'var(--blue-ultra-light)';
  section.style.padding = '3.5rem 0';
  section.style.overflow = 'hidden';

  const lang = getLocale() || 'en';
  const testimonials = testimonialsData[lang] || testimonialsData.en;

  const ui = {
    en: { verified: 'Verified Source:', eyebrow: 'EXPERT TESTIMONIALS' },
    cs: { verified: 'Ověřený zdroj:', eyebrow: 'HODNOCENÍ ODBORNÍKŮ' },
    de: { verified: 'Verifizierte Quelle:', eyebrow: 'EXPERTENMEINUNGEN' },
    es: { verified: 'Fuente verificada:', eyebrow: 'TESTIMONIOS DE EXPERTOS' },
    pt: { verified: 'Fonte verificada:', eyebrow: 'DEPOIMENTOS DE ESPECIALISTAS' },
    it: { verified: 'Fonte verificata:', eyebrow: 'TESTIMONIANZE DI ESPERTI' },
    ar: { verified: 'المصدر المعتمد:', eyebrow: 'آراء الخبراء وقادة الأمن' }
  };
  const currentUi = ui[lang] || ui.en;
  const verifiedLabel = currentUi.verified;
  const eyebrowText = currentUi.eyebrow;

  section.innerHTML = `
    <div class="sed-container">
      <div class="sed-section-header" style="margin-bottom: 2.5rem;">
        <div class="sed-eyebrow">${eyebrowText}</div>
        <h2 class="sed-section-title">${t('testimonials.title')}</h2>
        <p class="sed-section-desc" style="max-width: 680px; margin: 0 auto;">${t('testimonials.subtitle')}</p>
      </div>

      <!-- Carousel Container with Edge Clickable Arrow Controls -->
      <div style="position: relative;">
        
        <!-- Left Edge Clickable Arrow Overlay -->
        <button id="sed-testi-prev" aria-label="Previous Testimonial" style="position: absolute; left: -15px; top: 0; bottom: 0; width: 65px; z-index: 10; cursor: pointer; display: flex; align-items: center; justify-content: flex-start; padding-left: 5px; background: linear-gradient(90deg, rgba(240,247,252,0.95) 40%, rgba(240,247,252,0) 100%); border: none; border-radius: 12px 0 0 12px;">
          <div style="width: 44px; height: 44px; border-radius: 50%; background: #ffffff; color: var(--navy-dark); font-size: 1.3rem; font-weight: 900; display: flex; align-items: center; justify-content: center; box-shadow: 0 6px 18px rgba(0,0,0,0.15); border: 1.5px solid var(--slate-line); transition: transform 0.2s ease;">
            ❮
          </div>
        </button>

        <!-- Right Edge Clickable Arrow Overlay -->
        <button id="sed-testi-next" aria-label="Next Testimonial" style="position: absolute; right: -15px; top: 0; bottom: 0; width: 65px; z-index: 10; cursor: pointer; display: flex; align-items: center; justify-content: flex-end; padding-right: 5px; background: linear-gradient(-90deg, rgba(240,247,252,0.95) 40%, rgba(240,247,252,0) 100%); border: none; border-radius: 0 12px 12px 0;">
          <div style="width: 44px; height: 44px; border-radius: 50%; background: #ffffff; color: var(--navy-dark); font-size: 1.3rem; font-weight: 900; display: flex; align-items: center; justify-content: center; box-shadow: 0 6px 18px rgba(0,0,0,0.15); border: 1.5px solid var(--slate-line); transition: transform 0.2s ease;">
            ❯
          </div>
        </button>

        <!-- Movable Slider Track -->
        <div id="sed-testi-wrapper" class="sed-ticker-wrapper" style="mask-image: none; -webkit-mask-image: none; overflow-x: auto; scroll-behavior: smooth; scrollbar-width: none; padding: 0.5rem 0.5rem 1rem;">
          <div id="sed-testi-track" style="display: flex; gap: 1.5rem; width: max-content;">
            ${testimonials.map(item => `
              <div class="sed-card" style="width: 360px; min-width: 360px; min-height: 310px; display: flex; flex-direction: column; justify-content: space-between; background: #ffffff; border: 1.5px solid var(--slate-line); box-shadow: 0 4px 15px rgba(0,0,0,0.03); border-radius: 14px; box-sizing: border-box;">
                <div>
                  <div style="font-size: 0.95rem; color: var(--text-dark); line-height: 1.7; font-style: italic; margin-bottom: 1.25rem;">
                    "${item.quote}"
                  </div>
                </div>
                
                <div>
                  <div style="display: flex; align-items: center; gap: 12px; border-top: 1px solid var(--slate-line); padding-top: 1rem; margin-bottom: ${item.sourceUrl ? '0.85rem' : '0'};">
                    <img src="${item.img}" alt="${item.name}" style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover; border: 2px solid var(--blue-primary);" onerror="this.src='/images/Zuzana.png'">
                    <div>
                      <div style="font-family: var(--font-heading); font-weight: 800; font-size: 0.95rem; color: var(--navy-dark);">${item.name}</div>
                      <div style="font-size: 0.8rem; color: var(--text-muted); font-weight: 600;">${item.role}</div>
                    </div>
                  </div>
                  
                  ${item.sourceUrl ? `
                    <div style="background: #f8fafc; border-radius: 8px; padding: 6px 10px; border: 1px solid var(--slate-line); display: flex; align-items: center; justify-content: space-between; min-height: 34px; box-sizing: border-box;">
                      <span style="font-size: 0.72rem; font-weight: 700; color: var(--text-muted);">${verifiedLabel}</span>
                      <a href="${item.sourceUrl}" target="_blank" rel="noopener noreferrer" style="font-size: 0.76rem; font-weight: 800; color: var(--blue-primary); text-decoration: none; display: inline-flex; align-items: center; gap: 3px;" onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">
                        ${item.sourceLabel}
                      </a>
                    </div>
                  ` : ''}
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    </div>
  `;

  // Attach button event listeners for smooth scrolling
  setTimeout(() => {
    const wrapper = section.querySelector('#sed-testi-wrapper');
    const prevBtn = section.querySelector('#sed-testi-prev');
    const nextBtn = section.querySelector('#sed-testi-next');

    if (wrapper && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        wrapper.scrollBy({ left: -380, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        wrapper.scrollBy({ left: 380, behavior: 'smooth' });
      });
    }
  }, 0);

  return section;
}
